import { Building2 } from 'lucide-react';
import { useState } from 'react';
import type { Tenant } from '../../lib/api';
import styles from './TenantLogo.module.css';

interface TenantLogoProps {
  branding: Tenant['branding'];
  className?: string;
  tenantName: string;
  size: 'sm' | 'md' | 'lg';
  tone?: 'primary' | 'neutral';
}

export function TenantLogo({
  branding,
  className,
  tenantName,
  size,
  tone = 'primary',
}: TenantLogoProps) {
  const [failedLogoSrc, setFailedLogoSrc] = useState<string | null>(null);
  const logoUrl = branding?.logoUrl?.trim() || null;
  const logoBase64 = branding?.logoBase64?.trim() || null;
  const logoBase64AlreadyHasPrefix = Boolean(logoBase64?.startsWith('data:'));
  let logoBase64Src: string | null = null;

  if (logoBase64) {
    logoBase64Src = logoBase64AlreadyHasPrefix ? logoBase64 : `data:image/png;base64,${logoBase64}`;
  }

  const logoSrc = logoUrl ?? logoBase64Src;
  const logoIsVisible = Boolean(logoSrc && failedLogoSrc !== logoSrc);
  const logoClassName = className ? `${styles.logo} ${className}` : styles.logo;

  return (
    <span className={logoClassName} data-size={size} data-tone={tone}>
      {logoIsVisible ? (
        <img
          src={logoSrc ?? undefined}
          alt={`${tenantName} logo`}
          onError={() => setFailedLogoSrc(logoSrc)}
        />
      ) : (
        <Building2 className={styles.fallbackIcon} aria-hidden />
      )}
    </span>
  );
}
